// components/layout/Header.jsx
import React, { useState } from 'react';
import { Icon } from '../ui/Icon';
import { Button } from '../ui/Button';
import { useBrand } from '../../contexts/BrandContext';

export function Header({ user, onNavigate, onLogout, currentPage, cartItemCount = 0 }) {
  const { brand } = useBrand();
  const [showMenu, setShowMenu] = useState(false);
  const [showMobile, setShowMobile] = useState(false);
  
  const menuItems = brand.isB2B ? [
    { key: 'dashboard', label: 'Dashboard', icon: 'home' },
    { key: 'catalog', label: 'Catalog', icon: 'grid' },
    { key: 'vendors', label: 'Vendors', icon: 'link' },
    { key: 'purchase-orders', label: 'Orders', icon: 'clipboard' }
  ] : [
    { key: 'dashboard', label: 'Dashboard', icon: 'home' },
    { key: 'prescriptions', label: 'Prescriptions', icon: 'clipboard' },
    { key: 'orders', label: 'Orders', icon: 'package' },
    { key: 'messages', label: 'Messages', icon: 'mail' }
  ];
  
  return (
    <header style={{ 
      background: brand.c.headerBg, 
      color: 'white',
      position: 'sticky',
      top: 0,
      zIndex: 1000,
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
    }}>
      <div style={{ 
        maxWidth: 1200, 
        margin: '0 auto', 
        padding: '0 24px', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        height: 72
      }}>
        {/* Logo */}
        <div 
          onClick={() => onNavigate(user ? 'dashboard' : 'landing')}
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 12,
            cursor: 'pointer'
          }}
        >
          <div style={{
            width: 40,
            height: 40,
            borderRadius: 8,
            background: brand.logo ? 'transparent' : brand.c.accent,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden'
          }}>
            {brand.logo ? (
              <img src={brand.logo} alt={brand.name} style={{ width: 40, height: 40, objectFit: 'contain' }} />
            ) : (
              <Icon name="shield" size={20} color="#fff" />
            )}
          </div>
          <div>
            <div style={{ 
              fontSize: 18, 
              fontWeight: 900,
              fontFamily: "'Merriweather', serif"
            }}>
              {brand.name}
            </div>
            <div style={{ 
              fontSize: 10, 
              opacity: 0.8,
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              fontWeight: 600
            }}>
              {brand.tagline}
            </div>
          </div>
        </div>
        
        {user ? (
          <>
            {/* Desktop Nav */}
            <nav style={{ 
              display: 'flex', 
              gap: 8,
              alignItems: 'center'
            }} className="desktop-nav">
              {menuItems.map(item => (
                <button
                  key={item.key}
                  onClick={() => onNavigate(item.key)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '10px 16px',
                    border: 'none',
                    borderRadius: 8,
                    background: currentPage === item.key ? 'rgba(255,255,255,0.15)' : 'transparent',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: 14,
                    fontWeight: 600,
                    transition: 'background 0.2s',
                    fontFamily: 'Libre Franklin, sans-serif'
                  }}
                  onMouseEnter={(e) => {
                    if (currentPage !== item.key) {
                      e.target.style.background = 'rgba(255,255,255,0.1)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (currentPage !== item.key) {
                      e.target.style.background = 'transparent';
                    }
                  }}
                >
                  <Icon name={item.icon} size={16} />
                  {item.label}
                </button>
              ))}
              
              {/* Cart Button */}
              <button
                onClick={() => onNavigate('cart')}
                style={{
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 40,
                  height: 40,
                  border: 'none',
                  borderRadius: 8,
                  background: currentPage === 'cart' ? 'rgba(255,255,255,0.15)' : 'transparent',
                  color: 'white',
                  cursor: 'pointer',
                  marginLeft: 8,
                  transition: 'background 0.2s'
                }}
                onMouseEnter={(e) => { if (currentPage !== 'cart') e.target.style.background = 'rgba(255,255,255,0.1)'; }}
                onMouseLeave={(e) => { if (currentPage !== 'cart') e.target.style.background = 'transparent'; }}
              >
                <Icon name="cart" size={18} />
                {cartItemCount > 0 && (
                  <span style={{
                    position: 'absolute',
                    top: 2,
                    right: 2,
                    background: '#EF4444',
                    color: 'white',
                    fontSize: 10,
                    fontWeight: 800,
                    width: 18,
                    height: 18,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    lineHeight: 1
                  }}>
                    {cartItemCount > 99 ? '99+' : cartItemCount}
                  </span>
                )}
              </button>

              {/* User Menu */}
              <div style={{ position: 'relative', marginLeft: 8 }}>
                <button
                  onClick={() => setShowMenu(!showMenu)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    padding: '8px 12px',
                    border: 'none',
                    borderRadius: 8,
                    background: showMenu ? 'rgba(255,255,255,0.15)' : 'rgba(255,255,255,0.08)',
                    color: 'white',
                    cursor: 'pointer',
                    fontFamily: 'Libre Franklin, sans-serif'
                  }}
                >
                  <div style={{
                    width: 32,
                    height: 32,
                    borderRadius: 6,
                    background: 'rgba(255,255,255,0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 12,
                    fontWeight: 800
                  }}>
                    {user.firstName?.[0]}{user.lastName?.[0]}
                  </div>
                  <Icon name="chevDown" size={16} />
                </button>
                
                {showMenu && (
                  <div style={{
                    position: 'absolute',
                    right: 0,
                    top: 'calc(100% + 8px)',
                    background: 'white',
                    borderRadius: 12,
                    boxShadow: '0 12px 40px rgba(0,0,0,0.18)',
                    border: '1px solid #E5E7EB',
                    minWidth: 220,
                    padding: 8,
                    zIndex: 50
                  }}>
                    <div style={{ 
                      padding: '12px 16px', 
                      borderBottom: '1px solid #F3F4F6',
                      marginBottom: 8
                    }}>
                      <div style={{ 
                        fontSize: 14, 
                        fontWeight: 700,
                        color: '#111827'
                      }}>
                        {user.firstName} {user.lastName}
                      </div>
                      <div style={{ 
                        fontSize: 12, 
                        color: '#6B7280',
                        marginTop: 2
                      }}>
                        {user.email}
                      </div>
                    </div>
                    
                    <button
                      onClick={() => {
                        onNavigate('profile');
                        setShowMenu(false);
                      }}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                        width: '100%',
                        padding: '10px 16px',
                        border: 'none',
                        background: 'transparent',
                        cursor: 'pointer',
                        borderRadius: 8,
                        fontSize: 14,
                        color: '#374151',
                        fontFamily: 'Libre Franklin, sans-serif',
                        textAlign: 'left'
                      }}
                    >
                      <Icon name="user" size={16} />
                      Profile
                    </button>
                    
                    <button
                      onClick={() => {
                        onNavigate('savings');
                        setShowMenu(false);
                      }}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                        width: '100%',
                        padding: '10px 16px',
                        border: 'none',
                        background: 'transparent',
                        cursor: 'pointer',
                        borderRadius: 8,
                        fontSize: 14,
                        color: '#374151',
                        fontFamily: 'Libre Franklin, sans-serif',
                        textAlign: 'left'
                      }}
                    >
                      <Icon name="dollar" size={16} />
                      {brand.isB2B ? 'Spend Analysis' : 'Cost Savings'}
                    </button>
                    
                    <div style={{ 
                      height: 1, 
                      background: '#F3F4F6',
                      margin: '8px 0'
                    }} />
                    
                    <button
                      onClick={() => {
                        onLogout();
                        setShowMenu(false);
                      }}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                        width: '100%',
                        padding: '10px 16px',
                        border: 'none',
                        background: 'transparent',
                        cursor: 'pointer',
                        borderRadius: 8,
                        fontSize: 14,
                        color: '#EF4444',
                        fontFamily: 'Libre Franklin, sans-serif',
                        textAlign: 'left',
                        fontWeight: 600
                      }}
                    >
                      <Icon name="logout" size={16} />
                      Sign Out
                    </button>
                  </div>
                )}
              </div>
            </nav>
            
            {/* Mobile Menu Button */}
            <button
              className="mobile-menu-btn"
              onClick={() => setShowMobile(!showMobile)}
              style={{
                display: 'none',
                padding: 8,
                border: 'none',
                background: 'transparent',
                color: 'white',
                cursor: 'pointer'
              }}
            >
              <Icon name={showMobile ? 'x' : 'menu'} size={24} />
            </button>
          </>
        ) : (
          <div style={{ display: 'flex', gap: 12 }}>
            <Button 
              variant="ghost" 
              size="sm"
              onClick={() => onNavigate('login')}
              style={{ color: 'rgba(255,255,255,0.9)' }}
            >
              Sign In
            </Button>
            <Button 
              variant="gold" 
              size="sm"
              onClick={() => onNavigate('register')}
            >
              {brand.ctaText}
            </Button>
          </div>
        )}
      </div>
      
      {/* Mobile Menu */}
      {showMobile && user && (
        <div style={{
          background: brand.c.navy,
          borderTop: '1px solid rgba(255,255,255,0.1)',
          padding: 16
        }}>
          {menuItems.map(item => (
            <button
              key={item.key}
              onClick={() => {
                onNavigate(item.key);
                setShowMobile(false);
              }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                width: '100%',
                padding: '12px 16px',
                border: 'none',
                borderRadius: 8,
                background: currentPage === item.key ? 'rgba(255,255,255,0.15)' : 'transparent',
                color: 'white',
                cursor: 'pointer',
                fontSize: 14,
                fontWeight: 600,
                marginBottom: 4,
                fontFamily: 'Libre Franklin, sans-serif',
                textAlign: 'left'
              }}
            >
              <Icon name={item.icon} size={16} />
              {item.label}
            </button>
          ))}
        </div>
      )}
      
      <style>{`
        @media (max-width: 768px) {
          .desktop-nav {
            display: none !important;
          }
          .mobile-menu-btn {
            display: block !important;
          }
        }
      `}</style>
    </header>
  );
}
